module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('reservation-link', {
    tag: "div",
    attrs: {
      "direction": 0
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-bd422f1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd422f1c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationLinkIn.vue
// module id = 1975
// module chunks = 0